export const admins: string[] = [
    'dderbas@osdb.io',
    'ihorbatenko@osdb.io',
    'rhys.g.tanner@gmail.com',
    'Jo@makeitsimple.co.uk',
    'jakewattis99@gmail.com',
    'oshnyra@osdb.io',
    'ben@makeitsimple.co.uk',
    'john.fitzsimmons@flowledger.io',
]